import { authFetch } from '@/utils/auth-fetch';
import { Card, CardContent } from '@/components/ui/card';

// Shared by the Content delivery page's two tabs (OrgContentDelivery, OrgContentDeliveryActivity).

// The server caches both reports for 10 minutes; the page polls at the same pace.
export const REFRESH_MS = 10 * 60_000;

export const fmt = (n: number) => n.toLocaleString('en-US');

export async function getJson<T>(url: string): Promise<T> {
  const res = await authFetch(url);
  if (!res.ok) {
    let detail = '';
    try { const b = await res.json(); detail = b.message || b.error || ''; } catch { /* body is not JSON */ }
    throw new Error(`${res.status}${detail ? ` — ${detail}` : ''}`);
  }
  return res.json() as Promise<T>;
}

export function csvText(rows: string[][]): string {
  return rows.map((r) => r.map((cell) => (/[",\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell)).join(',')).join('\n');
}

export function download(filename: string, text: string) {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export type Tone = 'good' | 'warn' | 'bad' | 'none';

export function SummaryTile({ label, value, sub, tone }: { label: string; value: string; sub: string; tone?: Tone }) {
  const stripe = tone === 'good' ? 'bg-emerald-500' : tone === 'warn' ? 'bg-amber-500' : tone === 'bad' ? 'bg-rose-500' : 'bg-transparent';
  return (
    <Card className="relative overflow-hidden">
      <span className={`absolute inset-y-0 left-0 w-1 ${stripe}`} aria-hidden="true" />
      <CardContent className="pt-5">
        <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</div>
        <div className="text-3xl font-bold tabular-nums mt-1">{value}</div>
        <div className="text-xs text-muted-foreground mt-1">{sub}</div>
      </CardContent>
    </Card>
  );
}
